import {IRange} from "@pg-design/inputs-module";
import {gtmEcommerceOfferTypeMap, OfferType} from "@pg-rp/common-types";

import {constructionEndDateOptions} from "../../../real_estate/constants/construction_end_date_options";
import {floorChoices} from "../../../search/constants/filter_slot_presets/floor_choices";
import {houseAdditionalAreas} from "../../../search/constants/filter_slot_presets/house_additional_areas";
import {houseStoreys} from "../../../search/constants/filter_slot_presets/house_storeys";
import {houseType} from "../../../search/constants/filter_slot_presets/house_type";
import {IFilterOptionsValue, toFilterOptionValues} from "../../../search/utils/to_filter_option_values";

const ROOMS_MIN = 1;
const ROOMS_MAX = 5;

export const floorChoiceOptions = floorChoices.filters[0].filterOptions;
export const houseTypeOptions = houseType.filters[0].filterOptions;
export const houseAdditionalAreasOptions = houseAdditionalAreas.filters[0].filterOptions;
export const houseStoreysOptions = houseStoreys.filters[0].filterOptions;

export const mapPropertyType = (types: OfferType[]): string | undefined => {
    if (!types?.length) {
        return undefined;
    }
    return types.map((type) => gtmEcommerceOfferTypeMap[type]).join("|");
};

export const mapBudget = (price: IRange<string | number>, instalment?: string | number): string | undefined => {
    if (instalment !== undefined && instalment !== "") {
        return `${instalment}|Rata kredytu`;
    }
    if (price?.upper) {
        return `${price.upper}|Budżet`;
    }
    return undefined;
};

export const mapRooms = (rooms: IRange<number | "">): string | undefined => {
    const lower = typeof rooms?.lower === "number" ? rooms.lower : undefined;
    const upper = typeof rooms?.upper === "number" ? rooms.upper : undefined;

    if (lower === undefined && upper === undefined) {
        return undefined;
    }

    const from = lower ?? ROOMS_MIN;
    const to = upper ?? ROOMS_MAX;

    const values: number[] = [];
    for (let i = from; i <= to; i++) {
        values.push(i);
    }

    return values.join("|");
};

export const mapArea = (area?: IRange<string>): string | undefined => {
    if (!area) {
        return undefined;
    }
    const {lower, upper} = area;
    if (!lower && !upper) {
        return undefined;
    }
    return `${lower ?? ""}|${upper ?? ""}`;
};

export const mapFromFilterOptions = (values: IFilterOptionsValue, options: {value: string; label: string}[]): string | undefined => {
    const stringValues = toFilterOptionValues(values);
    if (!stringValues.length) {
        return undefined;
    }
    return stringValues
        .map((value) => options.find((option) => option.value === value)?.label)
        .filter(Boolean)
        .join("|");
};

export const mapCompletionDate = (dates?: number[]): string | undefined => {
    if (!dates?.length) {
        return undefined;
    }
    return dates
        .map((date) => constructionEndDateOptions.find((option) => option.value === date)?.label)
        .filter(Boolean)
        .join("|");
};
import {IRange} from "@pg-design/inputs-module";
import {gtmEcommerceOfferTypeMap, OfferType} from "@pg-rp/common-types";

import {constructionEndDateOptions} from "../../../real_estate/constants/construction_end_date_options";
import {floorChoices} from "../../../search/constants/filter_slot_presets/floor_choices";
import {houseAdditionalAreas} from "../../../search/constants/filter_slot_presets/house_additional_areas";
import {houseStoreys} from "../../../search/constants/filter_slot_presets/house_storeys";
import {houseType} from "../../../search/constants/filter_slot_presets/house_type";
import {IFilterOptionsValue, toFilterOptionValues} from "../../../search/utils/to_filter_option_values";

const ROOMS_MIN = 1;
const ROOMS_MAX = 5;

export const floorChoiceOptions = floorChoices.filters[0].filterOptions;
export const houseTypeOptions = houseType.filters[0].filterOptions;
export const houseAdditionalAreasOptions = houseAdditionalAreas.filters[0].filterOptions;
export const houseStoreysOptions = houseStoreys.filters[0].filterOptions;

export const mapPropertyType = (types: OfferType[]): string | undefined => {
    if (!types?.length) {
        return undefined;
    }
    return types.map((type) => gtmEcommerceOfferTypeMap[type]).join("|");
};

export const mapBudget = (price: IRange<string | number>, instalment?: string | number): string | undefined => {
    if (instalment !== undefined && instalment !== "") {
        return `${instalment}|Rata kredytu`;
    }
    if (price?.upper) {
        return `${price.upper}|Budżet`;
    }
    return undefined;
};

export const mapRooms = (rooms: IRange<number | "">): string | undefined => {
    const lower = typeof rooms?.lower === "number" ? rooms.lower : undefined;
    const upper = typeof rooms?.upper === "number" ? rooms.upper : undefined;

    if (lower === undefined && upper === undefined) {
        return undefined;
    }

    const from = lower ?? ROOMS_MIN;
    const to = upper ?? ROOMS_MAX;

    const values: number[] = [];
    for (let i = from; i <= to; i++) {
        values.push(i);
    }

    return values.join("|");
};

export const mapArea = (area?: IRange<string>): string | undefined => {
    if (!area) {
        return undefined;
    }
    const {lower, upper} = area;
    if (!lower && !upper) {
        return undefined;
    }
    return `${lower ?? ""}|${upper ?? ""}`;
};

export const mapFromFilterOptions = (values: IFilterOptionsValue, options: {value: string; label: string}[]): string | undefined => {
    const stringValues = toFilterOptionValues(values);
    if (!stringValues.length) {
        return undefined;
    }
    return stringValues
        .map((value) => options.find((option) => option.value === value)?.label)
        .filter(Boolean)
        .join("|");
};

export const mapCompletionDate = (dates?: number[]): string | undefined => {
    if (!dates?.length) {
        return undefined;
    }
    return dates
        .map((date) => constructionEndDateOptions.find((option) => option.value === date)?.label)
        .filter(Boolean)
        .join("|");
};
